import i18n from "@/libs/i18n"
import UserAddress from "@/pages/User/UserAddress/UserAddress.vue"
import PointHistory from "@/pages/User/PointHistory/PointHistory.vue"
import ListOrders from '../pages/Ecom/ListOrders.vue'

export const ORDERS_STATUS = {
  RECEIVE_ORDERS: 1,
  PROCESSING: 2,
  // SENDING: 3,
  FINISHED: 3,
  CANCELED: 4,
  WAITING_CONFIRM: 6,
  ERROR_PAYMENT: 7,
}

export const DELIVERY_STATUS = {
  RECEIVED: 1,
  SAMPLE_TAKEN: 2,
  PROCESSING: 3,
  PAYMENT: 4,
  SENDING: 5,
  FINISHED: 6,
  DELIVERED: 7,
}

export const PRODUCT_TYPE = {
  PRODUCT: 1,
  SERVICE: 2,
}

export const PRODUCT_ON_HODO = {
  UNAVAILABLE: 1,
  PENDING_AVAILABLE: 2,
  AVAILABLE: 3,
  REJECT_AVAILABLE: 4,
  ARCHIVE_AVAILABLE: 50,
}

export const PRODUCT_ON_INVENTORY_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
}

export const PRODUCT_CERTIFICATES_STATES = {
  DRAFF: 0,
  WAITING: 1,
  VERIFIED: 2,
  REJECTED: 3,
}

export const ORDER_FORM_STATUS_OPTIONS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
}
export const SUPPLIER_ORDERS_STATUS = {
  CANCELED: 100,
}

export const MESSAGE_CODE_LOGIN_ERROR = 12345
export const MESSAGE_CODE_LOGIN_INCORRECT = i18n.t(
  "lbl_error_check_email_and_password"
)

export const ROLES_SYSTEM = {
  ALL: "All",
  SUPPLIER: 1,
  PROCESSOR: 2,
  SUPPLIER_PRODUCT: 3,
}

export const ORDER_FORM_CONFIG_STATUS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
}

export const ORDER_FORM_PROCESSOR_STATUS = {
  PENDING: 1,
  PROCESSING: 2,
  COMPLETE: 3,
  CANCEL: 4,
  SUPPLIER_CANCEL: 100,
}

export const HODOCONFIG_FIREBASE = {
  firebaseKey:
    "BB-wTadF8XkPvbqf0popurYLgNUiqE18PzDtyZCSLZD_INwc7ajHz8LDY4UXDieERpG5dyXMnnqyaHsq-qOOUpY",
}

export const RESULT_ORDER_ITEM_STATUS = {
  NOT_APPROVE: 1,
  APPROVE: 2,
}

export const ORDER_FORM_DRAFT = {
  REQUISITION_FORM: 1,
  RESULT_FORM: 2,
  RESULT_PROCESSOR: 3,
}

export const NOTIFICATION_TYPE = {
  SUPPLIER: 1,
  PROCESSOR: 2,
}

export const NOTIFICATION_STATUS_TYPE = {
  CREATE: 1,
  SUPPLIER_UPDATE: 2,
  PROCESSOR_UPDATE: 3,
  SUPPLIER_REJECT_LAB: 4,
  NEW_COMMENT: 5,
}

export const RESULT_FORM_TYPE = {
  SUPPLIER: 1,
  PROCESSOR: 2,
}

export const PAYMENT_TYPE = [
  {
    label: i18n.t("lbl_not_payment"),
    value: 1,
    class: "text-warning",
  },
  {
    label: i18n.t("lbl_paid"),
    value: 2,
    class: "text-success",
  },
  {
    label: i18n.t("lbl_canceled_bill"),
    value: 3,
    class: "text-danger",
  },
]

export const PAYMENT_METHOD = {
  offline: 1,
  online: 2,
  points: 3
}

export const INTERNAL_ORDER_STATUS = {
  RECEIVE_ORDERS: 1,
  PROCESSING: 2,
  SALING: 3,
  DELIVERABLE: 4,
  FINISHED: 5
}

export const INTERNAL_PAYMENT_STATUS = {
  UNPAID: 1,
  PAID: 2,
  CANCELLED: 3
}

export const MARKETPLACE_USER_PROFILE_MENUS = [
  {
    key: "address",
    icon: "M9 5C8.25832 5 7.5333 5.21993 6.91661 5.63199C6.29993 6.04404 5.81928 6.62971 5.53545 7.31494C5.25162 8.00016 5.17736 8.75416 5.32205 9.48159C5.46675 10.209 5.8239 10.8772 6.34835 11.4017C6.8728 11.9261 7.54098 12.2833 8.26841 12.4279C8.99584 12.5726 9.74984 12.4984 10.4351 12.2145C11.1203 11.9307 11.706 11.4501 12.118 10.8334C12.5301 10.2167 12.75 9.49168 12.75 8.75C12.75 7.75544 12.3549 6.80161 11.6517 6.09835C10.9484 5.39509 9.99456 5 9 5ZM9 11C8.55499 11 8.11998 10.868 7.74997 10.6208C7.37996 10.3736 7.09157 10.0222 6.92127 9.61104C6.75097 9.1999 6.70642 8.7475 6.79323 8.31105C6.88005 7.87459 7.09434 7.47368 7.40901 7.15901C7.72368 6.84434 8.12459 6.63005 8.56105 6.54323C8.9975 6.45642 9.4499 6.50097 9.86104 6.67127C10.2722 6.84157 10.6236 7.12996 10.8708 7.49997C11.118 7.86998 11.25 8.30499 11.25 8.75C11.25 9.34674 11.0129 9.91903 10.591 10.341C10.169 10.7629 9.59674 11 9 11ZM9 0.5C6.81273 0.502481 4.71575 1.37247 3.16911 2.91911C1.62247 4.46575 0.752481 6.56273 0.75 8.75C0.75 11.6938 2.11031 14.8138 4.6875 17.7734C5.84552 19.1108 7.14886 20.3151 8.57344 21.3641C8.69954 21.4524 8.84978 21.4998 9.00375 21.4998C9.15772 21.4998 9.30796 21.4524 9.43406 21.3641C10.856 20.3147 12.1568 19.1104 13.3125 17.7734C15.8859 14.8138 17.25 11.6938 17.25 8.75C17.2475 6.56273 16.3775 4.46575 14.8309 2.91911C13.2843 1.37247 11.1873 0.502481 9 0.5ZM9 19.8125C7.45031 18.5938 2.25 14.1172 2.25 8.75C2.25 6.95979 2.96116 5.2429 4.22703 3.97703C5.4929 2.71116 7.20979 2 9 2C10.7902 2 12.5071 2.71116 13.773 3.97703C15.0388 5.2429 15.75 6.95979 15.75 8.75C15.75 14.1153 10.5497 18.5938 9 19.8125Z",
    title: "Địa chỉ nhận hàng",
    component: UserAddress,
    active: false
  },
  {
    key: "order",
    icon: "M18.97 5.2017L10.72 0.687639C10.4996 0.565841 10.2518 0.501953 10 0.501953C9.74816 0.501953 9.50043 0.565841 9.28 0.687639L1.03 5.20358C0.794395 5.33249 0.597722 5.52229 0.460517 5.75316C0.323313 5.98404 0.25061 6.24751 0.25 6.51608V15.4823C0.25061 15.7509 0.323313 16.0144 0.460517 16.2452C0.597722 16.4761 0.794395 16.6659 1.03 16.7948L9.28 21.3108C9.50043 21.4326 9.74816 21.4965 10 21.4965C10.2518 21.4965 10.4996 21.4326 10.72 21.3108L18.97 16.7948C19.2056 16.6659 19.4023 16.4761 19.5395 16.2452C19.6767 16.0144 19.7494 15.7509 19.75 15.4823V6.51701C19.7499 6.24797 19.6774 5.98391 19.5402 5.7525C19.403 5.52108 19.206 5.33084 18.97 5.2017ZM10 2.00014L17.5319 6.12514L14.7409 7.65326L7.20813 3.52826L10 2.00014ZM10 10.2501L2.46812 6.12514L5.64625 4.38514L13.1781 8.51014L10 10.2501ZM1.75 7.43764L9.25 11.542V19.5848L1.75 15.4833V7.43764ZM18.25 15.4795L10.75 19.5848V11.5458L13.75 9.9042V13.2501C13.75 13.4491 13.829 13.6398 13.9697 13.7805C14.1103 13.9211 14.3011 14.0001 14.5 14.0001C14.6989 14.0001 14.8897 13.9211 15.0303 13.7805C15.171 13.6398 15.25 13.4491 15.25 13.2501V9.08295L18.25 7.43764V15.4786V15.4795Z",
    title: "Đơn hàng",
    component: ListOrders,
    active: false
  },
  {
    key: "credit",
    icon: "M15.6103 3.25844C14.4787 1.31875 12.93 0.25 11.25 0.25H6.75C5.07 0.25 3.52125 1.31875 2.38969 3.25844C1.33219 5.07062 0.75 7.46875 0.75 10C0.75 12.5312 1.33219 14.9294 2.38969 16.7416C3.52125 18.6812 5.07 19.75 6.75 19.75H11.25C12.93 19.75 14.4787 18.6812 15.6103 16.7416C16.6678 14.9294 17.25 12.5312 17.25 10C17.25 7.46875 16.6678 5.07062 15.6103 3.25844ZM15.7303 9.25H12.7303C12.6717 7.71096 12.3653 6.19145 11.8228 4.75H14.6906C15.2644 6.00437 15.6431 7.5625 15.7303 9.25ZM13.7991 3.25H11.1056C10.7924 2.70655 10.4146 2.2029 9.98063 1.75H11.25C12.1875 1.75 13.0688 2.3125 13.7991 3.25ZM2.25 10C2.25 5.52812 4.3125 1.75 6.75 1.75C9.1875 1.75 11.25 5.52812 11.25 10C11.25 14.4719 9.1875 18.25 6.75 18.25C4.3125 18.25 2.25 14.4719 2.25 10ZM11.25 18.25H9.98344C10.4174 17.7971 10.7952 17.2935 11.1084 16.75H13.8019C13.0688 17.6875 12.1875 18.25 11.25 18.25ZM14.6906 15.25H11.8237C12.3662 13.8085 12.6727 12.289 12.7313 10.75H15.7313C15.6431 12.4375 15.2644 13.9956 14.6906 15.25Z",
    title: "HODO Credit",
    component: PointHistory,
    active: false
  },
  // {
  //   key: "policy",
  //   icon: "M17.0306 4.21938L13.2806 0.469375C13.2109 0.399749 13.1282 0.344539 13.0371 0.306898C12.9461 0.269257 12.8485 0.249923 12.75 0.25H5.25C4.85218 0.25 4.47064 0.408035 4.18934 0.68934C3.90804 0.970645 3.75 1.35218 3.75 1.75V3.25H2.25C1.85218 3.25 1.47064 3.40804 1.18934 3.68934C0.908035 3.97064 0.75 4.35218 0.75 4.75V18.25C0.75 18.6478 0.908035 19.0294 1.18934 19.3107C1.47064 19.592 1.85218 19.75 2.25 19.75H12.75C13.1478 19.75 13.5294 19.592 13.8107 19.3107C14.092 19.0294 14.25 18.6478 14.25 18.25V16.75H15.75C16.1478 16.75 16.5294 16.592 16.8107 16.3107C17.092 16.0294 17.25 15.6478 17.25 15.25V4.75C17.2501 4.65148 17.2307 4.55391 17.1931 4.46286C17.1555 4.37182 17.1003 4.28908 17.0306 4.21938ZM12.75 18.25H2.25V4.75H9.43969L12.75 8.06031V15.985C12.75 15.9906 12.75 15.9953 12.75 16C12.75 16.0047 12.75 16.0094 12.75 16.015V18.25ZM15.75 15.25H14.25V7.75C14.2501 7.65148 14.2307 7.55391 14.1931 7.46286C14.1555 7.37182 14.1003 7.28908 14.0306 7.21937L10.2806 3.46938C10.2109 3.39975 10.1282 3.34454 10.0371 3.3069C9.94609 3.26926 9.84852 3.24992 9.75 3.25H5.25V1.75H12.4397L15.75 5.06031V15.25ZM10.5 12.25C10.5 12.4489 10.421 12.6397 10.2803 12.7803C10.1397 12.921 9.94891 13 9.75 13H5.25C5.05109 13 4.86032 12.921 4.71967 12.7803C4.57902 12.6397 4.5 12.4489 4.5 12.25C4.5 12.0511 4.57902 11.8603 4.71967 11.7197C4.86032 11.579 5.05109 11.5 5.25 11.5H9.75C9.94891 11.5 10.1397 11.579 10.2803 11.7197C10.421 11.8603 10.5 12.0511 10.5 12.25ZM10.5 15.25C10.5 15.4489 10.421 15.6397 10.2803 15.7803C10.1397 15.921 9.94891 16 9.75 16H5.25C5.05109 16 4.86032 15.921 4.71967 15.7803C4.57902 15.6397 4.5 15.4489 4.5 15.25C4.5 15.0511 4.57902 14.8603 4.71967 14.7197C4.86032 14.579 5.05109 14.5 5.25 14.5H9.75C9.94891 14.5 10.1397 14.579 10.2803 14.7197C10.421 14.8603 10.5 15.0511 10.5 15.25Z",
  //   title: "Quy định bảo mật",
  //   component: "",
  //   active: false
  // },
  // {
  //   key: "help",
  //   icon: "M11.125 14.875C11.125 15.0975 11.059 15.315 10.9354 15.5C10.8118 15.685 10.6361 15.8292 10.4305 15.9144C10.225 15.9995 9.99876 16.0218 9.78053 15.9784C9.5623 15.935 9.36184 15.8278 9.20451 15.6705C9.04718 15.5132 8.94003 15.3127 8.89662 15.0945C8.85321 14.8762 8.87549 14.65 8.96064 14.4445C9.04579 14.2389 9.18998 14.0632 9.37499 13.9396C9.55999 13.816 9.7775 13.75 10 13.75C10.2984 13.75 10.5845 13.8685 10.7955 14.0795C11.0065 14.2905 11.125 14.5766 11.125 14.875ZM10 4.75C7.93188 4.75 6.25 6.26406 6.25 8.125V8.5C6.25 8.69891 6.32902 8.88968 6.46967 9.03033C6.61033 9.17098 6.80109 9.25 7 9.25C7.19892 9.25 7.38968 9.17098 7.53033 9.03033C7.67099 8.88968 7.75 8.69891 7.75 8.5V8.125C7.75 7.09375 8.75969 6.25 10 6.25C11.2403 6.25 12.25 7.09375 12.25 8.125C12.25 9.15625 11.2403 10 10 10C9.80109 10 9.61033 10.079 9.46967 10.2197C9.32902 10.3603 9.25 10.5511 9.25 10.75V11.5C9.25 11.6989 9.32902 11.8897 9.46967 12.0303C9.61033 12.171 9.80109 12.25 10 12.25C10.1989 12.25 10.3897 12.171 10.5303 12.0303C10.671 11.8897 10.75 11.6989 10.75 11.5V11.4325C12.46 11.1184 13.75 9.75437 13.75 8.125C13.75 6.26406 12.0681 4.75 10 4.75ZM19.75 10C19.75 11.9284 19.1782 13.8134 18.1068 15.4168C17.0355 17.0202 15.5127 18.2699 13.7312 19.0078C11.9496 19.7458 9.98919 19.9389 8.09787 19.5627C6.20656 19.1865 4.46928 18.2579 3.10571 16.8943C1.74215 15.5307 0.813554 13.7934 0.437348 11.9021C0.061142 10.0108 0.254225 8.05042 0.992179 6.26884C1.73013 4.48726 2.97982 2.96451 4.58319 1.89317C6.18657 0.821828 8.07164 0.25 10 0.25C12.585 0.25273 15.0634 1.28084 16.8913 3.10872C18.7192 4.93661 19.7473 7.41498 19.75 10ZM18.25 10C18.25 8.3683 17.7661 6.77325 16.8596 5.41655C15.9531 4.05984 14.6646 3.00242 13.1571 2.37799C11.6497 1.75357 9.99085 1.59019 8.39051 1.90852C6.79017 2.22685 5.32016 3.01259 4.16637 4.16637C3.01259 5.32015 2.22685 6.79016 1.90853 8.3905C1.5902 9.99085 1.75358 11.6496 2.378 13.1571C3.00242 14.6646 4.05984 15.9531 5.41655 16.8596C6.77326 17.7661 8.36831 18.25 10 18.25C12.1873 18.2475 14.2843 17.3775 15.8309 15.8309C17.3775 14.2843 18.2475 12.1873 18.25 10Z",
  //   title: "Trợ giúp",
  //   component: "",
  //   active: false
  // }
]
export const DEPOSIT_SCOPE = {
  org: 1,
  ws: 2
}

export const ORDER_DELIVERY_STATES = [
  { order_number: 1, date: null, max_steps: 5, title: "Chờ xử lý", title_done: 'Đã tiếp nhận' },
  { order_number: 2, date: null, max_steps: 5, title: "Đang xử lý", title_done: 'Đã xử lý' },
  { order_number: 3, date: null, max_steps: 5, title: "Xuất kho", title_done: 'Đã xuất kho' },
  { order_number: 4, date: null, max_steps: 5, title: "Giao hàng", title_done: 'Đã giao hàng' },
  { order_number: 5, date: null, max_steps: 5, title: "Hoàn thành", title_done: 'Hoàn thành' },
]

export const TRANSACTION_ERROR = [
  { value: "1", label: "lbl_the_bank_refused_to_authorize_the_transaction_" },
  {
    value: "2",
    label: "lbl_the_card_issuing_bank_refuses_to_authorize_the_transaction_",
  },
  {
    value: "3",
    label: "lbl_no_response_has_been_received_from_the_card_issuer_",
  },
  {
    value: "4",
    label:
      "lbl_the_card_s_expiration_month_year_is_incorrect_or_the_card_has_expired_",
  },
  { value: "5", label: "lbl_card_balance_limit_is_not_enough_for_payment_" },
  {
    value: "6",
    label: "lbl_no_response_has_been_received_from_the_card_issuer_",
  },
  {
    value: "7",
    label: "lbl_error_in_the_bank_s_transaction_processing_process_",
  },
  {
    value: "8",
    label: "lbl_the_card_issuing_bank_does_not_support_online_payments_",
  },
  { value: "9", label: "lbl_invalid_cardholder_account_name_" },
  { value: "10", label: "lbl_expired_card_card_locked_" },
  {
    value: "11",
    label:
      "lbl_card_account_has_not_registered_for_online_payment_support_service_",
  },
  {
    value: "12",
    label: "lbl_month_year_of_issuance_or_expiration_of_the_card_is_invalid_",
  },
  {
    value: "13",
    label:
      "lbl_transactions_exceeding_the_online_payment_limit_according_to_the_bank_s_regulations_",
  },
  { value: "14", label: "lbl_invalid_card_number_" },
  { value: "21", label: "lbl_account_balance_is_not_enough_for_payment_" },
  { value: "22", label: "lbl_invalid_account_information_" },
  { value: "23", label: "lbl_card_account_is_locked_or_not_activated_" },
  { value: "24", label: "lbl_invalid_card_account_information_" },
  { value: "25", label: "lbl_otp_authentication_code_is_invalid_" },
  { value: "26", label: "lbl_the_otp_authentication_code_has_expired_" },
  { value: "98", label: "lbl_transaction_validation_is_cancelled" },
  { value: "99", label: "lbl_user_cancels_transaction_" },
  {
    value: "B",
    label:
      "lbl_error_during_transaction_authentication_by_the_card_issuing_bank_",
  },
  {
    value: "D",
    label:
      "lbl_error_during_transaction_authentication_by_the_card_issuing_bank_",
  },
  { value: "F", label: "lbl_csc_code_validation_failed_" },
  { value: "U", label: "lbl_transaction_validation_failed_" },
  { value: "Z", label: "lbl_transaction_declined_" },
  {
    value: "253",
    label: "lbl_the_deadline_for_entering_payment_information_has_expired_",
  },
  { value: "", label: "lbl_an_unknown_error_" },
];